import {takeLatest,takeEvery, all} from 'redux-saga/effects';
import API from '../services/Api';
import AuthAPI from '../services/AuthApi';

/* ------------- Types ------------- */

import {StartupTypes} from '../redux/StartupRedux';

import {LanguageTypes} from '../redux/LanguageRedux';

import {AuthTypes} from '../redux/AuthRedux';

import {UserProfileTypes} from '../redux/UserProfileRedux';

import {DictionariesTypes} from '../redux/DictionariesRedux';

import {SearchTypes} from '../redux/SearchRedux';

import {DiagnosticTypes} from '../redux/DiagnosticRedux';

import {DealersTypes} from '../redux/DealersRedux';
import {DealerTypes} from '../redux/DealerRedux';

import {UsersTypes} from '../redux/UsersRedux';
import {UserTypes} from '../redux/UserRedux';

import {ReportsTypes} from '../redux/ReportsRedux';
import {ReportTypes} from '../redux/ReportRedux';

import {NotificationsTypes} from '../redux/NotificationsRedux';
import {NotificationTypes} from '../redux/NotificationRedux';

import {ClientsTypes} from '../redux/ClientsRedux';
import {ClientTypes} from '../redux/ClientRedux';

import {CarsTypes} from '../redux/CarsRedux';
import {CarErrorsTypes} from '../redux/CarErrorsRedux';

import {BillingTypes} from '../redux/BillingRedux';
/* ------------- Sagas ------------- */

import {startup} from './StartupSagas';

import {changeLanguage} from './LanguageSagas';

import {
  login, 
  refreshToken, 
  logout, 
  rememberPassword,
} from './AuthSagas';

import {getUserProfile} from './UserProfileSagas';

import {getDictionaries} from './DictionariesSagas';

import {getSearch} from './SearchSagas';

import {getDiagnostic} from './DiagnosticSagas';

import {getDealers} from './DealersSagas';
import {
  getDealer, 
  addDealer, 
  updateDealer, 
  deleteDealer,
} from './DealerSagas';

import {getUsers} from './UsersSagas';
import {
  getUser, 
  addUser, 
  updateUser, 
  deleteUser,
} from './UserSagas';

import {getReports} from './ReportsSagas';
import {
  getReport, 
  addReport, 
  updateReport, 
  deleteReport,
} from './ReportSagas';

import {getNotifications} from './NotificationsSagas';
import {
  getNotification, 
  addNotification, 
  updateNotification, 
  deleteNotification,
} from './NotificationSagas';

import {getClients} from './ClientsSagas';
import {
  getClient, 
  addClient, 
  updateClient, 
  deleteClient,
} from './ClientSagas';

import {
  updateCar, 
  checkCar, 
  addCar, 
  deleteCar,
} from './CarSagas';
import {
  getCarErrors, 
  deleteCarErrors, 
  getCarErrorsArchive,
} from './CarErrorsSagas';

import {CarFirmwaresTypes} from '../redux/CarFirmwaresRedux'; // FOTA
import {
  getCarFirmwares, 
  downloadXlsByFilter,
} from './CarFirmwaresSagas';

import {FotaCarTypes} from '../redux/FotaCarRedux'; 
import {
  getFotaCar, 
  addFotaCar, 
  updateFotaCar, 
  deleteFotaCar,
} from './FotaCarSagas.js';

import {FirmwaresTypes} from '../redux/FirmwaresRedux.js';
import {getFirmwares} from './FirmwaresSagas';

import {FirmwareTypes} from '../redux/FirmwareRedux.js';
import {
  getFirmware, 
  addFirmware, 
  addFirmwareFile, 
  updateFirmware,
  deleteFirmware, 
  getFirmwareComments, 
  addFirmwareComments, 
  downloadFirmwareFile, 
  updateFirmwareWithFile,
} from './FirmwareSagas.js';

import {CampaignsTypes} from '../redux/CampaignsRedux.js';
import {getCampaigns} from './CampaignsSagas.js';

import {CampaignTypes} from '../redux/CampaignRedux.js';
import { 
  getCampaign, 
  updateCampaign, 
  deleteCampaign, 
  createCampaign,
  uploadVinFile, 
  uploadParsedVins, 
  uploadCarsFilter
} from './CampaignSagas.js';

import {
  getBilling, 
  downloadBilling,
} from './BillingSagas';
  
/* ------------- API ------------- */

// The API we use is only used from Sagas, so we create it here and pass along
// to the sagas which need it.
const api = API.create(); //FixtureAPI
const authApi = AuthAPI.create();

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  yield all([
    takeLatest(StartupTypes.STARTUP, startup),

    takeLatest(LanguageTypes.LANGUAGE_CHANGE_REQUEST, changeLanguage, authApi, api),

    takeLatest(AuthTypes.LOGIN_REQUEST, login, authApi, api),
    takeLatest(AuthTypes.LOGOUT_REQUEST, logout, authApi, api),
    takeLatest(AuthTypes.REMEMBER_PASSWORD_REQUEST, rememberPassword, authApi),
    takeLatest(AuthTypes.AUTO_LOGIN, refreshToken, authApi, api),

    takeLatest(UserProfileTypes.USER_PROFILE_REQUEST, getUserProfile, api),

    takeEvery(DictionariesTypes.DICTIONARIES_REQUEST, getDictionaries, api),

    takeLatest(SearchTypes.SEARCH_REQUEST, getSearch, api),

    takeLatest(DiagnosticTypes.DIAGNOSTIC_REQUEST, getDiagnostic, api),

    takeLatest(DealersTypes.DEALERS_REQUEST, getDealers, api),
    takeLatest(DealerTypes.DEALER_REQUEST, getDealer, api),
    takeLatest(DealerTypes.DEALER_ADD_REQUEST, addDealer, api),
    takeLatest(DealerTypes.DEALER_UPDATE_REQUEST, updateDealer, api),
    takeLatest(DealerTypes.DEALER_DELETE_REQUEST, deleteDealer, api),

    takeLatest(UsersTypes.USERS_REQUEST, getUsers, api),
    takeLatest(UserTypes.USER_REQUEST, getUser, api),
    takeLatest(UserTypes.USER_ADD_REQUEST, addUser, api),
    takeLatest(UserTypes.USER_UPDATE_REQUEST, updateUser, api),
    takeLatest(UserTypes.USER_DELETE_REQUEST, deleteUser, api),

    takeLatest(ReportsTypes.REPORTS_REQUEST, getReports, api),
    takeLatest(ReportTypes.REPORT_REQUEST, getReport, api),
    takeLatest(ReportTypes.REPORT_ADD_REQUEST, addReport, api),
    takeLatest(ReportTypes.REPORT_UPDATE_REQUEST, updateReport, api),
    takeLatest(ReportTypes.REPORT_DELETE_REQUEST, deleteReport, api),

    takeLatest(NotificationsTypes.NOTIFICATIONS_REQUEST, getNotifications, api),
    takeLatest(NotificationTypes.NOTIFICATION_REQUEST, getNotification, api),
    takeLatest(NotificationTypes.NOTIFICATION_ADD_REQUEST, addNotification, api),
    takeLatest(NotificationTypes.NOTIFICATION_UPDATE_REQUEST, updateNotification, api),
    takeLatest(NotificationTypes.NOTIFICATION_DELETE_REQUEST, deleteNotification, api),

    takeLatest(ClientsTypes.CLIENTS_REQUEST, getClients, api),
    takeLatest(ClientTypes.CLIENT_REQUEST, getClient, api),
    takeLatest(ClientTypes.CLIENT_ADD_REQUEST, addClient, api),
    takeLatest(ClientTypes.CLIENT_UPDATE_REQUEST, updateClient, api),
    takeLatest(ClientTypes.CLIENT_DELETE_REQUEST, deleteClient, api),

    takeLatest(CarsTypes.CAR_CHECK_REQUEST, checkCar, api),
    takeLatest(CarsTypes.CAR_ADD_REQUEST, addCar, api),
    takeLatest(CarsTypes.CAR_UPDATE_REQUEST, updateCar, api),
    takeLatest(CarsTypes.CAR_DELETE_REQUEST, deleteCar, api),

    takeEvery(CarErrorsTypes.CAR_ERRORS_REQUEST, getCarErrors, api),
    takeEvery(CarErrorsTypes.CAR_ERRORS_CLEAN_REQUEST, deleteCarErrors, api),
    takeLatest(CarErrorsTypes.CAR_ERRORS_ARCHIVE_REQUEST, getCarErrorsArchive, api),

    takeLatest(FirmwaresTypes.FIRMWARES_REQUEST, getFirmwares, api),
    takeLatest(FirmwareTypes.FIRMWARE_REQUEST, getFirmware, api),
    takeLatest(FirmwareTypes.FIRMWARE_FILE_ADD_REQUEST, addFirmwareFile, api),
    takeLatest(FirmwareTypes.FIRMWARE_ADD_REQUEST, addFirmware, api),
    takeLatest(FirmwareTypes.FIRMWARE_UPDATE_REQUEST, updateFirmware, api),
    takeLatest(FirmwareTypes.FIRMWARE_DELETE_REQUEST, deleteFirmware, api),
    takeLatest(FirmwareTypes.FIRMWARE_COMMENT_ADD_REQUEST, addFirmwareComments, api),
    takeLatest(FirmwareTypes.FIRMWARE_COMMENT_GET_REQUEST, getFirmwareComments, api),
    takeLatest(FirmwareTypes.UPDATE_FIRMWARE_WITH_FILE, updateFirmwareWithFile, api),
    takeLatest(FirmwareTypes.FIRMWARE_FILE_DOWNLOAD_REQUEST, downloadFirmwareFile, api),

    takeLatest(CarFirmwaresTypes.CAR_FIRMWARES_REQUEST, getCarFirmwares, api), // FOTACars
    takeLatest(CarFirmwaresTypes.DOWNLOAD_XLS_BY_FILTER_REQUEST, downloadXlsByFilter, api), // FOTACars

    takeLatest(FotaCarTypes.FOTA_CAR_REQUEST, getFotaCar, api),
    takeLatest(FotaCarTypes.FOTA_CAR_ADD_REQUEST, addFotaCar, api),
    takeLatest(FotaCarTypes.FOTA_CAR_UPDATE_REQUEST, updateFotaCar, api),
    takeLatest(FotaCarTypes.FOTA_CAR_DELETE_REQUEST, deleteFotaCar, api),


    takeLatest(CampaignsTypes.CAMPAIGNS_REQUEST, getCampaigns, api),
    takeLatest(CampaignTypes.CAMPAIGN_REQUEST, getCampaign, api),
    takeLatest(CampaignTypes.UPDATE_CAMPAIGN_REQUEST, updateCampaign, api),
    takeLatest(CampaignTypes.DELETE_CAMPAIGN_REQUEST, deleteCampaign, api),
    takeLatest(CampaignTypes.CREATE_CAMPAIGN_REQUEST, createCampaign, api),
    
    takeLatest(CampaignTypes.UPLOAD_VIN_FILE_REQUEST, uploadVinFile, api),
    takeLatest(CampaignTypes.UPLOAD_PARSED_VINS_REQUEST, uploadParsedVins, api),
    takeLatest(CampaignTypes.UPLOAD_CARS_FILTER_REQUEST, uploadCarsFilter, api),

    takeLatest(BillingTypes.BILLING_REQUEST, getBilling, api),
    takeLatest(BillingTypes.BILLING_DOWNLOAD_REQUEST, downloadBilling, api),
  ]);
}
